import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row } from 'reactstrap';
import Select from 'react-select';
import AutoComplete from 'components/molecules/autocompleteFilter';
import AutoCompleteClinics from 'components/molecules/autocompleteFilter/clinic';
import AutoCompleteDoctors from 'components/molecules/autocompleteFilter/doctor';
import forms from 'constants/forms';
import common from 'constants/common';
import TimeFilter from '../../../../organisms/timeFilter';

const DEFAULT_FILTER = forms.patientFilterOptions[0];
const DEFAULT_DOCTOR_FILTER = forms.doctorFilterOptions[0];
const DEFAULT_CLINIC_FILTER = forms.clinicFilterOptions[0];
const DEFAULT_STATUS = forms.statusSelect[0];
const DEFAULT_SORT = forms.sortSelect[0];
const DEFAULT_INSURANCE = forms.clinicInsuranceTypeSelect[0];

const Sorting = () => {
  const { insuranceTypes, filters } = useSelector((state) => state.doctor);

  const {
    doctor: { applyFilters, applyTimeFilter },
  } = useDispatch();

  const filter = DEFAULT_FILTER;
  const clinicsFilter = DEFAULT_CLINIC_FILTER;
  const doctorFilter = DEFAULT_DOCTOR_FILTER;
  const handleSubmit = (dates) => {
    applyTimeFilter(dates);
  };

  const handleOnChange = (option) => {
    if (option) {
      const { value } = option;
      applyFilters({ patientGuid: value });
    }
  };

  const selectTheme = (theme) => ({
    ...theme,
    borderRadius: 12,
    colors: {
      ...theme.colors,
      ...common.primaryColors,
    },
  });

  return (
    <Row>
      <Col xl="2" xs="12" md="6">
        <p className="realtime-heading">Report Time Window</p>
        <TimeFilter noUTC handleSubmit={handleSubmit} />
      </Col>
      <Col xl="2" xs="12" md="6">
        <p className="realtime-heading">Patient Filter</p>
        <AutoComplete filter={filter} handleClick={handleOnChange} />
      </Col>
      <Col xl="2" xs="12" md="6">
        <p className="realtime-heading">Show Status</p>
        <Select
          options={forms.statusSelect}
          defaultValue={DEFAULT_STATUS}
          theme={(theme) => selectTheme(theme)}
          classNamePrefix="select-type"
          onChange={({ value }) => applyFilters({ status: value })}
        />
      </Col>
      <Col xl="2" xs="12" md="6">
        <p className="realtime-heading">Sort</p>
        <Select
          options={forms.sortSelect}
          defaultValue={DEFAULT_SORT}
          theme={(theme) => selectTheme(theme)}
          classNamePrefix="select-type"
          onChange={({ value }) => applyFilters({ reverse: value })}
        />
      </Col>

      <Col xl="2" xs="12" md="6">
        <p className="realtime-heading">Clinic</p>
        <AutoCompleteClinics
          filter={clinicsFilter}
          handleClick={({ value }) => {
            if (value) {
              applyFilters({ clinicGuid: value });
            } else {
              applyFilters({
                clinicGuid: '',
                insuranceType: DEFAULT_INSURANCE.value,
                doctorGuid: '',
              });
            }
          }}
        />
      </Col>
      {filters.clinicGuid && (
        <Col xl="2" xs="12" md="6">
          <p className="realtime-heading">Insurance Provider</p>
          <Select
            options={[
              DEFAULT_INSURANCE,
              ...insuranceTypes.map((insuranceType) => ({
                label: insuranceType,
                value: insuranceType,
              })),
            ]}
            defaultValue={DEFAULT_INSURANCE}
            theme={(theme) => selectTheme(theme)}
            classNamePrefix="select-type"
            onChange={({ value }) => applyFilters({ insuranceType: value })}
          />
        </Col>
      )}
      {filters.clinicGuid && (
        <Col xl="2" xs="12" md="6">
          <p className="realtime-heading">Practice</p>
          <AutoCompleteDoctors
            clinicGuid={filters.clinicGuid}
            filter={doctorFilter}
            handleClick={({ value }) => {
              applyFilters({ doctorGuid: value });
            }}
          />
        </Col>
      )}
    </Row>
  );
};

export default Sorting;
